var TimeScales = {
  MINUTE: "minute",
  HOUR: "hour",
  DAY: "day"
};

module.exports = TimeScales;



// WEBPACK FOOTER //
// ./src/js/constants/TimeScales.js